// extracted by mini-css-extract-plugin
export default {"trigger":"Collapse_trigger__RHNrm","chevron":"Collapse_chevron__P-nqS"};